import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardActionArea from "@mui/material/CardActionArea";
import Typography from "@mui/material/Typography";
import PhotoLibraryOutlinedIcon from "@mui/icons-material/PhotoLibraryOutlined";
import { useNavigate } from "react-router-dom";

const MuralCardV2 = ({ mural }) => {
  const navigate = useNavigate();

  return (
    <Card
      variant="outlined"
      sx={{
        width: { xs: "100%", sm: 250 },
        transition: "box-shadow .2s, transform .2s",
        "&:hover": { boxShadow: 4, transform: "translateY(-2px)" },
      }}
    >
      <CardActionArea onClick={() => navigate("/mural-foto-usuario", { state: { mural } })}>
        <Box
          sx={{
            aspectRatio: "4 / 3",
            bgcolor: "action.hover",
            color: "text.disabled",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {mural.fotoCapa ? (
            <Box
              component="img"
              src={mural.fotoCapa}
              alt=""
              loading="lazy"
              sx={{ width: "100%", height: "100%", objectFit: "cover" }}
            />
          ) : (
            <PhotoLibraryOutlinedIcon fontSize="large" />
          )}
        </Box>
        <Typography
          variant="body2"
          fontWeight={500}
          title={mural.descricao}
          sx={{
            px: 1.5,
            py: 1.25,
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
          }}
        >
          {mural.descricao}
        </Typography>
      </CardActionArea>
    </Card>
  );
};

export default MuralCardV2;
